export const adminConstants = {
	//Auth
	LOGIN_ADMIN_REQUEST	: 'LOGIN_ADMIN_REQUEST',
	LOGIN_ADMIN_SUCCESS	: 'LOGIN_ADMIN_SUCCESS',
	LOGIN_ADMIN_FAILURE	: 'LOGIN_ADMIN_FAILURE',
	LOGOUT_ADMIN 		: 'LOGOUT_ADMIN',

	//Company

	GET_DASHBOARD_REQUEST : 'GET_DASHBOARD_REQUEST',
	GET_DASHBOARD_SUCCESS : 'GET_DASHBOARD_SUCCESS',
	GET_DASHBOARD_FAILURE : 'GET_DASHBOARD_FAILURE',

	
	GET_COMPANY_REQUEST : 'GET_COMPANY_REQUEST',
	GET_COMPANY_SUCCESS : 'GET_COMPANY_SUCCESS',
	GET_COMPANY_FAILURE : 'GET_COMPANY_FAILURE',

	STORE_COMPANY_REQUEST : 'STORE_COMPANY_REQUEST',
	STORE_COMPANY_SUCCESS : 'STORE_COMPANY_SUCCESS',
	STORE_COMPANY_FAILURE : 'STORE_COMPANY_FAILURE',

	EDIT_COMPANY_REQUEST : 'EDIT_COMPANY_REQUEST',
	EDIT_COMPANY_SUCCESS : 'EDIT_COMPANY_SUCCESS',
	EDIT_COMPANY_FAILURE : 'EDIT_COMPANY_FAILURE',

	DELETE_COMPANY_REQUEST : 'DELETE_COMPANY_REQUEST',
	DELETE_COMPANY_SUCCESS : 'DELETE_COMPANY_SUCCESS',
	DELETE_COMPANY_FAILURE : 'DELETE_COMPANY_FAILURE',

	
	PAGINATION_COMPANY_REQUEST : 'PAGINATION_COMPANY_REQUEST',
	PAGINATION_COMPANY_SUCCESS : 'PAGINATION_COMPANY_SUCCESS',
	PAGINATION_COMPANY_FAILURE : 'PAGINATION_COMPANY_FAILURE',

	STORE_COMPANY_USER_REQUEST : 'STORE_COMPANY_USER_REQUEST',
	STORE_COMPANY_USER_SUCCESS : 'STORE_COMPANY_USER_SUCCESS',
	STORE_COMPANY_USER_FAILURE : 'STORE_COMPANY_USER_FAILURE',

	STORE_ADMIN_USER_REQUEST : 'STORE_ADMIN_USER_REQUEST',
	STORE_ADMIN_USER_SUCCESS : 'STORE_ADMIN_USER_SUCCESS',
	STORE_ADMIN_USER_FAILURE : 'STORE_ADMIN_USER_FAILURE',

	GET_COMPANY_USER_REQUEST : 'GET_COMPANY_USER_REQUEST',
	GET_COMPANY_USER_SUCCESS : 'GET_COMPANY_USER_SUCCESS',
	GET_COMPANY_USER_FAILURE : 'GET_COMPANY_USER_FAILURE',

	EDIT_COMPANY_USER_REQUEST : 'EDIT_COMPANY_USER_REQUEST',
	EDIT_COMPANY_USER_SUCCESS : 'EDIT_COMPANY_USER_SUCCESS',
	EDIT_COMPANY_USER_FAILURE : 'EDIT_COMPANY_USER_FAILURE',

	EDIT_ADMIN_USER_REQUEST : 'EDIT_ADMIN_USER_REQUEST',
	EDIT_ADMIN_USER_SUCCESS : 'EDIT_ADMIN_USER_SUCCESS',
	EDIT_ADMIN_USER_FAILURE : 'EDIT_ADMIN_USER_FAILURE',

	GET_COMPANY_USERS_REQUEST : 'GET_COMPANY_USERS_REQUEST',
	GET_COMPANY_USERS_SUCCESS : 'GET_COMPANY_USERS_SUCCESS',
	GET_COMPANY_USERS_FAILURE : 'GET_COMPANY_USERS_FAILURE',

	GET_ADMIN_USERS_REQUEST : 'GET_ADMIN_USERS_REQUEST',
	GET_ADMIN_USERS_SUCCESS : 'GET_ADMIN_USERS_SUCCESS',
	GET_ADMIN_USERS_FAILURE : 'GET_ADMIN_USERS_FAILURE',

	GET_ADMIN_USER_REQUEST: 'GET_ADMIN_USER_REQUEST',
	GET_ADMIN_USER_SUCCESS: 'GET_ADMIN_USER_SUCCESS',
	GET_ADMIN_USER_FAILURE: 'GET_ADMIN_USER_FAILURE',
	
	PAGINATION_FESTIVAL_REQUEST : 'PAGINATION_FESTIVAL_REQUEST',
	PAGINATION_FESTIVAL_SUCCESS : 'PAGINATION_FESTIVAL_SUCCESS',
	PAGINATION_FESTIVAL_FAILURE : 'PAGINATION_FESTIVAL_FAILURE',

	DELETE_COMPANY_USER_REQUEST : 'DELETE_COMPANY_USER_REQUEST',
	DELETE_COMPANY_USER_SUCCESS : 'DELETE_COMPANY_USER_SUCCESS',
	DELETE_COMPANY_USER_FAILURE : 'DELETE_COMPANY_USER_FAILURE',

	DELETE_ADMIN_USER_REQUEST : 'DELETE_ADMIN_USER_REQUEST',
	DELETE_ADMIN_USER_SUCCESS : 'DELETE_ADMIN_USER_SUCCESS',
	DELETE_ADMIN_USER_FAILURE : 'DELETE_ADMIN_USER_FAILURE',
	
	GET_FESTIVAL_REQUEST : 'GET_FESTIVAL_REQUEST',
	GET_FESTIVAL_SUCCESS : 'GET_FESTIVAL_SUCCESS',
	GET_FESTIVAL_FAILURE : 'GET_FESTIVAL_FAILURE',

	GET_FESTIVAL_COMMENTS_REQUEST : 'GET_FESTIVAL_COMMENTS_REQUEST',
	GET_FESTIVAL_COMMENTS_SUCCESS : 'GET_FESTIVAL_COMMENTS_SUCCESS',
	GET_FESTIVAL_COMMENTS_FAILURE : 'GET_FESTIVAL_COMMENTS_FAILURE',

	GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST : 'GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST',
	GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS : 'GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS',
	GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE : 'GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE',

	STORE_FESTIVAL_REQUEST : 'STORE_FESTIVAL_REQUEST',
	STORE_FESTIVAL_SUCCESS : 'STORE_FESTIVAL_SUCCESS',
	STORE_FESTIVAL_FAILURE : 'STORE_FESTIVAL_FAILURE',

	EDIT_FESTIVAL_REQUEST : 'EDIT_FESTIVAL_REQUEST',
	EDIT_FESTIVAL_SUCCESS : 'EDIT_FESTIVAL_SUCCESS',
	EDIT_FESTIVAL_FAILURE : 'EDIT_FESTIVAL_FAILURE',

	GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST : 'GET_FESTIVAL_MUSIC_DIRECTORS_REQUEST',
	GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS : 'GET_FESTIVAL_MUSIC_DIRECTORS_SUCCESS',
	GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE : 'GET_FESTIVAL_MUSIC_DIRECTORS_FAILURE',

	GET_FESTIVAL_ADJUDICATORS_REQUEST : 'GET_FESTIVAL_ADJUDICATORS_REQUEST',
	GET_FESTIVAL_ADJUDICATORS_SUCCESS : 'GET_FESTIVAL_ADJUDICATORS_SUCCESS',
	GET_FESTIVAL_ADJUDICATORS_FAILURE : 'GET_FESTIVAL_ADJUDICATORS_FAILURE',

	STORE_FESTIVAL_MUSIC_DIRECTOR_REQUEST : 'STORE_FESTIVAL_MUSIC_DIRECTOR_REQUEST',
	STORE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS : 'STORE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS',
	STORE_FESTIVAL_MUSIC_DIRECTOR_FAILURE : 'STORE_FESTIVAL_MUSIC_DIRECTOR_FAILURE',


	STORE_FESTIVAL_ADJUDICATOR_REQUEST : 'STORE_FESTIVAL_ADJUDICATOR_REQUEST',
	STORE_FESTIVAL_ADJUDICATOR_SUCCESS : 'STORE_FESTIVAL_ADJUDICATOR_SUCCESS',
	STORE_FESTIVAL_ADJUDICATOR_FAILURE : 'STORE_FESTIVAL_ADJUDICATOR_FAILURE',


	GET_FESTIVAL_MUSIC_DIRECTOR_REQUEST : 'GET_FESTIVAL_MUSIC_DIRECTOR_REQUEST',
	GET_FESTIVAL_MUSIC_DIRECTOR_SUCCESS : 'GET_FESTIVAL_MUSIC_DIRECTOR_SUCCESS',
	GET_FESTIVAL_MUSIC_DIRECTOR_FAILURE : 'GET_FESTIVAL_MUSIC_DIRECTOR_FAILURE',

	GET_FESTIVAL_ADJUDICATOR_REQUEST : 'GET_FESTIVAL_ADJUDICATOR_REQUEST',
	GET_FESTIVAL_ADJUDICATOR_SUCCESS : 'GET_FESTIVAL_ADJUDICATOR_SUCCESS',
	GET_FESTIVAL_ADJUDICATOR_FAILURE : 'GET_FESTIVAL_ADJUDICATOR_FAILURE',

	DELETE_FESTIVAL_REQUEST : 'DELETE_FESTIVAL_REQUEST',
	DELETE_FESTIVAL_SUCCESS : 'DELETE_FESTIVAL_SUCCESS',
	DELETE_FESTIVAL_FAILURE : 'DELETE_FESTIVAL_FAILURE',

	
	DELETE_FESTIVAL_MUSIC_DIRECTOR_REQUEST : 'DELETE_FESTIVAL_MUSIC_DIRECTOR_REQUEST',
	DELETE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS : 'DELETE_FESTIVAL_MUSIC_DIRECTOR_SUCCESS',
	DELETE_FESTIVAL_MUSIC_DIRECTOR_FAILURE : 'DELETE_FESTIVAL_MUSIC_DIRECTOR_FAILURE',

	DELETE_FESTIVAL_ADJUDICATOR_REQUEST : 'DELETE_FESTIVAL_ADJUDICATOR_REQUEST',
	DELETE_FESTIVAL_ADJUDICATOR_SUCCESS : 'DELETE_FESTIVAL_ADJUDICATOR_SUCCESS',
	DELETE_FESTIVAL_ADJUDICATOR_FAILURE : 'DELETE_FESTIVAL_ADJUDICATOR_FAILURE',

	EDIT_FESTIVAL_MUSIC_DIRECTORS_REQUEST : 'EDIT_FESTIVAL_MUSIC_DIRECTORS_REQUEST',
	EDIT_FESTIVAL_MUSIC_DIRECTORS_SUCCESS : 'EDIT_FESTIVAL_MUSIC_DIRECTORS_SUCCESS',
	EDIT_FESTIVAL_MUSIC_DIRECTORS_FAILURE : 'EDIT_FESTIVAL_MUSIC_DIRECTORS_FAILURE',


	EDIT_FESTIVAL_ADJUDICATOR_REQUEST : 'EDIT_FESTIVAL_ADJUDICATOR_REQUEST',
	EDIT_FESTIVAL_ADJUDICATOR_SUCCESS : 'EDIT_FESTIVAL_ADJUDICATOR_SUCCESS',
	EDIT_FESTIVAL_ADJUDICATOR_FAILURE : 'EDIT_FESTIVAL_ADJUDICATOR_FAILURE',

	GET_COMPANY_PROFILE_INFO_REQUEST : 'GET_COMPANY_PROFILE_INFO_REQUEST',
	GET_COMPANY_PROFILE_INFO_SUCCESS : 'GET_COMPANY_PROFILE_INFO_SUCCESS',
	GET_COMPANY_PROFILE_INFO_FAILURE : 'GET_COMPANY_PROFILE_INFO_FAILURE',

	CREATE_SHEET_FOR_FESTIVAL_REQUEST : 'CREATE_SHEET_FOR_FESTIVAL_REQUEST',
	CREATE_SHEET_FOR_FESTIVAL_SUCCESS : 'CREATE_SHEET_FOR_FESTIVAL_SUCCESS',
	CREATE_SHEET_FOR_FESTIVAL_FAILURE : 'CREATE_SHEET_FOR_FESTIVAL_FAILURE',

	GET_COMPANY_ALL_USERS_REQUEST : 'GET_COMPANY_ALL_USERS_REQUEST',
	GET_COMPANY_ALL_USERS_SUCCESS : 'GET_COMPANY_ALL_USERS_SUCCESS',
	GET_COMPANY_ALL_USERS_FAILURE : 'GET_COMPANY_ALL_USERS_FAILURE',

	GET_FESTIVAL_ALL_MUSIC_DIRECTORS_REQUEST : 'GET_FESTIVAL_ALL_MUSIC_DIRECTORS_REQUEST',
	GET_FESTIVAL_ALL_MUSIC_DIRECTORS_SUCCESS : 'GET_FESTIVAL_ALL_MUSIC_DIRECTORS_SUCCESS',
	GET_FESTIVAL_ALL_MUSIC_DIRECTORS_FAILURE : 'GET_FESTIVAL_ALL_MUSIC_DIRECTORS_FAILURE',

	GET_FESTIVAL_ALL_ADJUDICATORS_REQUEST : 'GET_FESTIVAL_ALL_ADJUDICATORS_REQUEST',
	GET_FESTIVAL_ALL_ADJUDICATORS_SUCCESS : 'GET_FESTIVAL_ALL_ADJUDICATORS_SUCCESS',
	GET_FESTIVAL_ALL_ADJUDICATORS_FAILURE : 'GET_FESTIVAL_ALL_ADJUDICATORS_FAILURE',
	
	STORE_USER_REQUEST : 'STORE_USER_REQUEST',
	STORE_USER_SUCCESS : 'STORE_USER_SUCCESS',
	STORE_USER_FAILURE : 'STORE_USER_FAILURE',
	
	GET_USER_REQUEST   : 'GET_USER_REQUEST',
	GET_USER_SUCCESS   : 'GET_USER_SUCCESS',
	GET_USER_FAILURE   : 'GET_USER_FAILURE',

	EDIT_USER_REQUEST  : 'EDIT_USER_REQUEST',
	EDIT_USER_SUCCESS  : 'EDIT_USER_SUCCESS',
	EDIT_USER_FAILURE  : 'EDIT_USER_FAILURE',

	DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
	DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
	DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',
	
	GET_USERS_REQUEST  : 'GET_USERS_REQUEST',
	GET_USERS_SUCCESS  : 'GET_USERS_SUCCESS',
	GET_USERS_FAILURE  : 'GET_USERS_FAILURE',

	CLOSE_USER_MODAL   : 'CLOSE_USER_MODAL',
	CLOSE_USER_EDIT_MODAL : 'CLOSE_USER_EDIT_MODAL',


	CHANGE_PRIMARY_USER_REQUEST : 'CHANGE_PRIMARY_USER_REQUEST',
	CHANGE_PRIMARY_USER_SUCCESS : 'CHANGE_PRIMARY_USER_SUCCESS',
	CHANGE_PRIMARY_USER_FAILURE : 'CHANGE_PRIMARY_USER_FAILURE',

	CHECK_USER_PERMISSIONS_REQUEST : 'CHECK_USER_PERMISSIONS_REQUEST',
	CHECK_USER_PERMISSIONS_SUCCESS : 'CHECK_USER_PERMISSIONS_SUCCESS',
	CHECK_USER_PERMISSIONS_FAILURE : 'CHECK_USER_PERMISSIONS_FAILURE',

	GET_EMAIL_TEMPLATES_REQUEST : 'GET_EMAIL_TEMPLATES_REQUEST',
	GET_EMAIL_TEMPLATES_SUCCESS : 'GET_EMAIL_TEMPLATES_SUCCESS',
	GET_EMAIL_TEMPLATES_FAILURE : 'GET_EMAIL_TEMPLATES_FAILURE',

	GET_EMAIL_TYPES_REQUEST : 'GET_EMAIL_TYPES_REQUEST ',
	GET_EMAIL_TYPES_SUCCESS : 'GET_EMAIL_TYPES_SUCCESS',
	GET_EMAIL_TYPES_FAILURE : 'GET_EMAIL_TYPES_FAILURE',

	STORE_EMAIL_TEMPLATES_REQUEST : 'STORE_EMAIL_TEMPLATES_REQUEST',
	STORE_EMAIL_TEMPLATES_SUCCESS : 'STORE_EMAIL_TEMPLATES_SUCCESS',
	STORE_EMAIL_TEMPLATES_FAILURE : 'STORE_EMAIL_TEMPLATES_FAILURE',

	EDIT_EMAIL_TEMPLATES_REQUEST : 'EDIT_EMAIL_TEMPLATES_REQUEST',
	EDIT_EMAIL_TEMPLATES_SUCCESS : 'EDIT_EMAIL_TEMPLATES_SUCCESS',
	EDIT_EMAIL_TEMPLATES_FAILURE : 'EDIT_EMAIL_TEMPLATES_FAILURE',

	DELETE_EMAIL_TEMPLATES_REQUEST : 'DELETE_EMAIL_TEMPLATES_REQUEST',
	DELETE_EMAIL_TEMPLATES_SUCCESS : 'DELETE_EMAIL_TEMPLATES_SUCCESS',
	DELETE_EMAIL_TEMPLATES_FAILURE : 'DELETE_EMAIL_TEMPLATES_FAILURE',

	GET_EMAIL_TEMPLATE_REQUEST : 'GET_EMAIL_TEMPLATE_REQUEST',
	GET_EMAIL_TEMPLATE_SUCCESS : 'GET_EMAIL_TEMPLATE_SUCCESS',
	GET_EMAIL_TEMPLATE_FAILURE : 'GET_EMAIL_TEMPLATE_FAILURE',

	GET_PRICE_PER_ADJUDICATION_REQUEST : 'GET_PRICE_PER_ADJUDICATION_REQUEST',
	GET_PRICE_PER_ADJUDICATION_SUCCESS : 'GET_PRICE_PER_ADJUDICATION_SUCCESS',
	GET_PRICE_PER_ADJUDICATION_FAILURE : 'GET_PRICE_PER_ADJUDICATION_FAILURE',

	STORE_MDMEDIA_REQUEST : 'STORE_MDMEDIA_REQUEST',
	STORE_MDMEDIA_SUCCESS : 'STORE_MDMEDIA_SUCCESS',
	STORE_MDMEDIA_FAILURE : 'STORE_MDMEDIA_FAILURE',

	GET_MDMEDIA_REQUEST : 'GET_MDMEDIA_REQUEST',
	GET_MDMEDIA_SUCCESS : 'GET_MDMEDIA_SUCCESS',
	GET_MDMEDIA_FAILURE : 'GET_MDMEDIA_FAILURE',

	DELETE_MDMEDIA_REQUEST : 'DELETE_MDMEDIA_REQUEST',
	DELETE_MDMEDIA_SUCCESS : 'DELETE_MDMEDIA_SUCCESS',
	DELETE_MDMEDIA_FAILURE : 'DELETE_MDMEDIA_FAILURE',
};


// WEBPACK FOOTER //
// ./src/redux/constant/admin-constant.jsx